var countRound = $('#countRounds').val(), // кол-во раундов
    timelineSwiper, // переменная для слайдера раундов
    battleInterval, // переменная для интервала раундов
    winUserItems = [], // выигранные предменты в раунде
    allWinUserItems = [], // выигранные предменты в раунде
    nowWinUserId = [], // ид пользователей с наивысшей стоимостью вещи в раунде
    showItemsFlag = false; // флаг для показа списка всех предметов в игре

$(function () {

    $('.coliseum-subhead__copy').on('click', function(e){
        e.preventDefault();
        let copyText = $(this).find('input')[0];
        copyText.select();
        copyText.setSelectionRange(0, 99999);
        document.execCommand("copy");
    });

    $('.battle-cases__header').on('click', function(e){
        e.preventDefault();
        $(this).closest('.battle-cases').toggleClass('active');
        if(showItemsFlag === false){
            let nowItemsHtml = '';
            for(let i = 0; i<gameCase.length; i++){
                for(let j = 0; j<gameCase[i].caseItems.length; j++){
                    let thisItem = gameCase[i].caseItems[j];
                    nowItemsHtml = nowItemsHtml + '<div class="battle-cases__el '+thisItem.rarity+'">' +
                        '                             <div class="battle-cases__img"><img src="'+thisItem.imageSm+'" alt=""></div>' +
                        '                             <div class="battle-cases__name">'+thisItem.name+'</div>' +
                        '                             <div class="battle-cases__cost"><img src="img/icon-dollar.png" alt=""> '+thisItem.cost+'</div>' +
                        '                           </div>';
                }
            }
            $('.battle-cases__wp').html(nowItemsHtml);
            showItemsFlag = true;
        }
        if($('.battle-cases').hasClass('active')){
            $('.battle-cases__body').slideDown();
        }else{
            $('.battle-cases__body').slideUp();
        }
    });

    timelineSwiper = new Swiper ('.battle-timeline', {
        slidesPerView: 'auto',
        initialSlide: 0,
        noSwiping: true,
        speed: 600,
        noSwipingClass: 'battle-timeline',
        preventInteractionOnTransition: true
    });

   /* if($('.battle-useers__status').length > 0){
        setTimeout(battleStart, 1500);
    }*/
});


function battleStart() { // Функция начала игры

    $('.battle-useers__status').html(' ');
    // $('.battle-useers__status').html(' ').removeClass('ready').addClass('lose');
    casePlay();

    battleInterval = setInterval(function(){
        if(timelineSwiper.activeIndex < countRound-1) {
            roundCounter();
        }else{
            clearInterval(battleInterval);
            endGameWinner();
        }
    },4000);
}

function roundCounter(){ // Функция перехода раунда
    timelineSwiper.slideNext();
    $('.battle-useers__rounds-count span').html(timelineSwiper.activeIndex + 1);
    casePlay();
}

function casePlay(){ // Функция розыгрыша раунда
  let nowItemsHtml = ''; // Пустышка для создания DOM элемента battle-game__el

    winUserItems = [];

    $('.battle-useers__status').removeClass('ready lose').addClass('start');

    for(let j = 0; j<gameCase[timelineSwiper.activeIndex].caseItems.length; j++){
        let thisItem = gameCase[timelineSwiper.activeIndex].caseItems[j];
        nowItemsHtml = nowItemsHtml + '<div class="battle-game__el">' +
            '                            <div class="battle-game__name">'+thisItem.name+' <span>('+thisItem.wear+')</span></div>' +
            '                            <div class="battle-game__img"><img src="'+thisItem.imageBig+'" alt=""></div>' +
            '                          </div>';
    }


    $('.battle-game').html('<div class="battle-game__wp">'+nowItemsHtml+'</div>');

    $('.battle-useers__el').each(function(){
        appendUserWinItem($(this).data('userid'));
    });
    getRoundWinnerId();

    setTimeout(function(){
        $('.battle-game__wp').css('top', '-1500%');
    },1);
}

function appendUserWinItem(userId) { // обработка раунда для конкретного пользователя
    let randomInt = Math.floor(Math.random() * 9 + 1), // рандомное число от 1 до 10 для определения выигранного предмета *** только для демки
        randomWinItem = gameCase[timelineSwiper.activeIndex].caseItems[randomInt], // получение рандомного выигранного предмета
        nowItemsHtml = '<div class="battle-game__el">' +
        '                            <div class="battle-game__name">'+randomWinItem.name+' <span>('+randomWinItem.wear+')</span></div>' +
        '                            <div class="battle-game__img"><img src="'+randomWinItem.imageBig+'" alt=""></div>' +
        '                          </div>'; // html для рандомного элемента вниз блока

    winUserItems.push({
        userId: userId,
        winItemCost: randomWinItem.cost
    });

    allWinUserItems.push(randomWinItem);

    $('.battle-useers__el').each(function(){
        let $this = $(this);

        if($this.data('userid') === userId){
            $this.find('.battle-game__wp').append(nowItemsHtml);

            setTimeout(function(){
                let nowUserWinItem = $this.find('.battle-useers__items');
                if(!nowUserWinItem.hasClass('active')){
                    nowUserWinItem.addClass('active');
                }

                calcUserProfit($this,randomWinItem);

                if(nowWinUserId.indexOf(userId) === -1){
                    $this.find('.battle-useers__status').removeClass('ready start').addClass('lose');
                }

                nowUserWinItem.find('.battle-useers__items-wp').append('<div class="battle-cases__el '+randomWinItem.rarity+'">' +
                    '              <div class="battle-cases__img"><img src="'+randomWinItem.imageSm+'" alt=""></div>' +
                    '              <div class="battle-cases__name">'+randomWinItem.name+'</div>' +
                    '              <div class="battle-cases__cost"><img src="img/icon-dollar.png" alt=""> '+randomWinItem.cost+'</div>' +
                    '            </div>')
            },3100);
        }
    });
}

function calcUserProfit(userHtml,caseItem){ // Функция подсчета общего выигрыша пользователей
    let nowHtmlCont = userHtml.find('.battle-useers__profit'), // DOM элемент общего выигрыша
        nowProfit = Number(nowHtmlCont.find('span').html()); // текущий общий выигрыш

    if(nowProfit === 0){
        nowHtmlCont.addClass('active');
    }

    nowHtmlCont.find('span').html((nowProfit + Number(caseItem.cost)).toFixed(2));
}

function getRoundWinnerId(){ // Функция определения ID польщователей с наивысшей ценой приза
    let nowWinUsersCosts = [], // массив со всеми ценами выигранных вещей
        maxWinUsersCosts = 0, // максимальная цена выигранной вещи
        maxWinIdx = 0, // индекс максимальной цены
        maxWinUsersCostsArr = []; // массив с всеми максимальными ценами

    nowWinUserId = [];

    for(let i = 0; i < winUserItems.length; i++){
        nowWinUsersCosts.push(Number(winUserItems[i].winItemCost));
    }

    maxWinUsersCosts = Math.max(...nowWinUsersCosts);

    maxWinIdx = nowWinUsersCosts.indexOf(maxWinUsersCosts);

    while (maxWinIdx !== -1) {
        maxWinUsersCostsArr.push(maxWinIdx);
        maxWinIdx = nowWinUsersCosts.indexOf(maxWinUsersCosts, maxWinIdx + 1);
    }

    for(let i = 0; i < maxWinUsersCostsArr.length; i++){
        nowWinUserId.push(winUserItems[maxWinUsersCostsArr[i]].userId);
    }
}

function endGameWinner() {
    let usersProfits = [],
        userProfitsMaxId = -1,
        userAllProfit = 0,
        endWinItemHtmlModal = '',
        endWinnerUserId = 0,
        endWinItemHtml = '';
    $('.battle-useers__el').each(function() {
        let $this = $(this);

        usersProfits.push(Number($this.find('.battle-useers__profit span').html()));
    });

    console.log('usersProfits ',usersProfits);

    userProfitsMaxId = Math.max(...usersProfits);

    endWinnerUserId = usersProfits.indexOf(userProfitsMaxId);


    for(let i = 0; i < allWinUserItems.length; i++){
        endWinItemHtmlModal+= '<div class="win-modal__items-el">' +
            '          <div class="win-modal__items-img '+allWinUserItems[i].rarity+'"><img src="'+allWinUserItems[i].imageSm+'" alt="'+allWinUserItems[i].name+'"></div>' +
            '          <div class="win-modal__items-info">' +
            '            <div class="win-modal__items-name">' +
            '              <div class="win-modal__items-title">'+allWinUserItems[i].name+'</div>' +
            '              <div class="win-modal__items-wear">'+allWinUserItems[i].wear+'</div>' +
            '            </div><a class="win-modal__items-btn" href="#"><img src="img/icon-truck.png" alt="dollar"><span>Sell for '+allWinUserItems[i].cost+' $</span></a>' +
            '          </div>' +
            '        </div>';

        endWinItemHtml+= '<div class="battle-cases__el '+allWinUserItems[i].rarity+'">' +
                    '       <div class="battle-cases__img"><img src="'+allWinUserItems[i].imageSm+'" alt=""></div>' +
                    '       <div class="battle-cases__name">'+allWinUserItems[i].name+'</div>' +
                    '       <div class="battle-cases__cost"><img src="img/icon-dollar.png" alt=""> '+allWinUserItems[i].cost+'</div>' +
                    '     </div>';

        userAllProfit+=Number(allWinUserItems[i].cost);
    }

    $('.win-modal__items').html(endWinItemHtmlModal);

    $('.battle-useers__status').removeClass('lose win start').html('<span>loser</span>');
    $('.battle-useers__el').addClass('lose')
                           .eq(endWinnerUserId)
                           .removeClass('lose')
                           .addClass('win')
                           .find('.battle-useers__items-wp').html(endWinItemHtml)
                           .closest('.battle-useers__el').find('.battle-useers__status').html('<span>Winner</span>' +
                                                                                              '<div><img src="img/icon-dollar_big.png" alt=""> '+userAllProfit.toFixed(2)+'</div>');

    console.log($('.battle-useers__el').eq(endWinnerUserId).attr('data-userid')+' === '+thisUserObj.id);

    if(Number($('.battle-useers__el').eq(endWinnerUserId).attr('data-userid')) === Number(thisUserObj.id)){
        $('.win-modal__text>span>span').html(allWinUserItems.length);
        $('.win-modal__profit span').html(userAllProfit.toFixed(2));
        $('.win-modal__overlay, .win-modal').addClass('active');
    }else{
        $('.lose-modal__overlay, .lose-modal').addClass('active');
        let loseModalUsers = '';
        $('.battle-useers__el').each(function(index){
            let $this = $(this);

            loseModalUsers+= '<div class="lose-modal__items-el '+(index === endWinnerUserId ? 'win' : 'lose')+'">' +
                '          <div class="lose-modal__items-img"><img src="'+$this.find('.battle-useers__avatar img').attr('src')+'" alt=""></div>' +
                '          <div class="lose-modal__items-title">'+$this.find('.battle-useers__name').html()+'</div>' +
                '          <div class="lose-modal__items-worth">Worth<span><i>$</i> '+$this.find('.battle-useers__profit span').html()+'</span></div>' +
                '          <div class="lose-modal__items-profit"><img src="img/icon-dollar2.png" alt=""><span>'+(index === endWinnerUserId ? userAllProfit.toFixed(2) : $('#caseProfits').val())+'</span></div>' +
                '        </div>';
        });
        $('.lose-modal__profit span').html(userAllProfit.toFixed(2));
        $('.lose-modal__items').html(loseModalUsers);
    }
}

$('.balance__close, .balance__overlay').on('click', function () {
    $('.balance_modal').removeClass('balance_open');
    $('.balance__overlay').removeClass('balance__overlay_open');
    $('.site_content').removeAttr('style');
    $('body').removeAttr('style');
});

$('.add-balance').on('click', function (e) {
    e.preventDefault();
    $('.balance_modal').addClass('balance_open');
    $('.balance__overlay').addClass('balance__overlay_open');
    $('.site_content').css('z-index', 1);
    $('body').css('overflow', 'hidden');
});


/*
var gameCase = [
    {
        'caseId': 0,
        'caseName': 'Random Milspec',
        'caseImg': 'https://dropland.net/uploads/cases/Mk0kl.png',
        'caseCost': '0.29',
        'caseItems': [
            {
                'id': 0,
                'name': 'P250 | Franklin',
                'wear': 'Field-Tested',
                'rarity': 'cl_1',
                'imageSm': 'https://steamcommunity-a.akamaihd.net/economy/image/-9a81dlWLwJ2UUGcVs_nsVtzdOEdtWwKGZZLQHTxDZ7I56KU0Zwwo4NUX4oFJZEHLbXH5ApeO4YmlhxYQknCRvCo04DEVlxkKgpopujwezhjxszFfjNH9eO6nYeDg8j4MqnWkyVQsJMi2OzF8dmt3AK28xBlNzzzLdWScwdvNQnU_Qe5lbu81pG_tc_O1zI97TldxTpO/150fx100f',
                'imageBig': 'https://steamcommunity-a.akamaihd.net/economy/image/-9a81dlWLwJ2UUGcVs_nsVtzdOEdtWwKGZZLQHTxDZ7I56KU0Zwwo4NUX4oFJZEHLbXH5ApeO4YmlhxYQknCRvCo04DEVlxkKgpopujwezhjxszFfjNH9eO6nYeDg8j4MqnWkyVQsJMi2OzF8dmt3AK28xBlNzzzLdWScwdvNQnU_Qe5lbu81pG_tc_O1zI97TldxTpO/200fx150f',
                'cost': '1.11'
            },
            {
                'id': 1,
                'name': 'R8 Revolver | Reboot',
                'wear': 'Minimal Wear',
                'rarity': 'cl_2',
                'imageSm': 'https://steamcommunity-a.akamaihd.net/economy/image/-9a81dlWLwJ2UUGcVs_nsVtzdOEdtWwKGZZLQHTxDZ7I56KU0Zwwo4NUX4oFJZEHLbXH5ApeO4YmlhxYQknCRvCo04DEVlxkKgpopL-zJAt21uH3cih9_oSJl5mJkuXnI7TDglRc7cF4n-T--Y3nj1H6r0ZuMm-lIoGQIwNsNF3W_la2l-m8hJe7vJqcyXQ26CEl4nfVyheyiAYMMLJhtAnBUQ/150fx100f',
                'imageBig': 'https://steamcommunity-a.akamaihd.net/economy/image/-9a81dlWLwJ2UUGcVs_nsVtzdOEdtWwKGZZLQHTxDZ7I56KU0Zwwo4NUX4oFJZEHLbXH5ApeO4YmlhxYQknCRvCo04DEVlxkKgpopL-zJAt21uH3cih9_oSJl5mJkuXnI7TDglRc7cF4n-T--Y3nj1H6r0ZuMm-lIoGQIwNsNF3W_la2l-m8hJe7vJqcyXQ26CEl4nfVyheyiAYMMLJhtAnBUQ/200fx150f',
                'cost': '2.22'
            },
            {
                'id': 2,
                'name': 'Tec-9 | toxic',
                'wear': 'Battle-Scarred',
                'rarity': 'cl_3',
                'imageSm': 'https://steamcommunity-a.akamaihd.net/economy/image/-9a81dlWLwJ2UUGcVs_nsVtzdOEdtWwKGZZLQHTxDZ7I56KU0Zwwo4NUX4oFJZEHLbXH5ApeO4YmlhxYQknCRvCo04DEVlxkKgpoor-mcjhoyszGZD5O6d2kq5OAgvv4IO7ugm5Ssfp9g-7J4bP5iUazrl04a2qnI9LAdlU_YQyCqVTokLvmh5PtuM6bzHFi6XEltHeJykDhgkxNcKUx0nqScxNZ/150fx100f',
                'imageBig': 'https://steamcommunity-a.akamaihd.net/economy/image/-9a81dlWLwJ2UUGcVs_nsVtzdOEdtWwKGZZLQHTxDZ7I56KU0Zwwo4NUX4oFJZEHLbXH5ApeO4YmlhxYQknCRvCo04DEVlxkKgpoor-mcjhoyszGZD5O6d2kq5OAgvv4IO7ugm5Ssfp9g-7J4bP5iUazrl04a2qnI9LAdlU_YQyCqVTokLvmh5PtuM6bzHFi6XEltHeJykDhgkxNcKUx0nqScxNZ/200fx150f',
                'cost': '3.33'
            },
            {
                'id': 3,
                'name': 'SSG 08 | Necropos',
                'wear': 'Well-Worn',
                'rarity': 'cl_4',
                'imageSm': 'https://steamcommunity-a.akamaihd.net/economy/image/-9a81dlWLwJ2UUGcVs_nsVtzdOEdtWwKGZZLQHTxDZ7I56KU0Zwwo4NUX4oFJZEHLbXH5ApeO4YmlhxYQknCRvCo04DEVlxkKgpopamie19f0Ob3Yi5FvISJmoWIhfjkPKjum25V4dB8teXA54vwxgfsrUQ4YjvxJYLHdwI4YVmGqFHqxO7v15G6uZubyHtl6XZ27X_YnhepwUYbGDyxDtI/150fx100f',
                'imageBig': 'https://steamcommunity-a.akamaihd.net/economy/image/-9a81dlWLwJ2UUGcVs_nsVtzdOEdtWwKGZZLQHTxDZ7I56KU0Zwwo4NUX4oFJZEHLbXH5ApeO4YmlhxYQknCRvCo04DEVlxkKgpopamie19f0Ob3Yi5FvISJmoWIhfjkPKjum25V4dB8teXA54vwxgfsrUQ4YjvxJYLHdwI4YVmGqFHqxO7v15G6uZubyHtl6XZ27X_YnhepwUYbGDyxDtI/200fx150f',
                'cost': '4.44'
            },
            {
                'id': 4,
                'name': 'mag-7 | heat',
                'wear': 'Factory New',
                'rarity': 'cl_5',
                'imageSm': 'https://steamcommunity-a.akamaihd.net/economy/image/-9a81dlWLwJ2UUGcVs_nsVtzdOEdtWwKGZZLQHTxDZ7I56KU0Zwwo4NUX4oFJZEHLbXH5ApeO4YmlhxYQknCRvCo04DEVlxkKgpou7uifDhjxszFcDoV086zkIiEg8j4OrzZglRd6dd2j6eWo9yt31Xs-EU5azr6LNDBcwY5Z12B_gO7x7q81J-4us-YzCMw6CR2-z-DyH05vt6N/150fx100f',
                'imageBig': 'https://steamcommunity-a.akamaihd.net/economy/image/-9a81dlWLwJ2UUGcVs_nsVtzdOEdtWwKGZZLQHTxDZ7I56KU0Zwwo4NUX4oFJZEHLbXH5ApeO4YmlhxYQknCRvCo04DEVlxkKgpou7uifDhjxszFcDoV086zkIiEg8j4OrzZglRd6dd2j6eWo9yt31Xs-EU5azr6LNDBcwY5Z12B_gO7x7q81J-4us-YzCMw6CR2-z-DyH05vt6N/200fx150f',
                'cost': '5.55'
            },
            {
                'id': 5,
                'name': 'AWP | paw',
                'wear': 'Not Painted',
                'rarity': 'cl_6',
                'imageSm': 'https://steamcommunity-a.akamaihd.net/economy/image/-9a81dlWLwJ2UUGcVs_nsVtzdOEdtWwKGZZLQHTxDZ7I56KU0Zwwo4NUX4oFJZEHLbXH5ApeO4YmlhxYQknCRvCo04DEVlxkKgpot621FAZt7PLfYQJS7cumlZe0m_7zO6_ummpD78A_2u_HpN2giwfl-ENrMDrwJYSXdwU4MlzUq1jvlLjo0JC4vprOnSFisz5iuygXqnotbQ/150fx100f',
                'imageBig': 'https://steamcommunity-a.akamaihd.net/economy/image/-9a81dlWLwJ2UUGcVs_nsVtzdOEdtWwKGZZLQHTxDZ7I56KU0Zwwo4NUX4oFJZEHLbXH5ApeO4YmlhxYQknCRvCo04DEVlxkKgpot621FAZt7PLfYQJS7cumlZe0m_7zO6_ummpD78A_2u_HpN2giwfl-ENrMDrwJYSXdwU4MlzUq1jvlLjo0JC4vprOnSFisz5iuygXqnotbQ/200fx150f',
                'cost': '6.66'
            }
        ]
    },
    {
        'caseId': 1,
        'caseName': 'Random Restricted',
        'caseImg': 'https://dropland.net/uploads/cases/jKhd2.png',
        'caseCost': '0.99',
        'caseItems': [
            {
                'id': 0,
                'name': 'P250 | Franklin',
                'wear': 'Field-Tested',
                'rarity': 'cl_1',
                'imageSm': 'https://steamcommunity-a.akamaihd.net/economy/image/-9a81dlWLwJ2UUGcVs_nsVtzdOEdtWwKGZZLQHTxDZ7I56KU0Zwwo4NUX4oFJZEHLbXH5ApeO4YmlhxYQknCRvCo04DEVlxkKgpopujwezhjxszFfjNH9eO6nYeDg8j4MqnWkyVQsJMi2OzF8dmt3AK28xBlNzzzLdWScwdvNQnU_Qe5lbu81pG_tc_O1zI97TldxTpO/150fx100f',
                'imageBig': 'https://steamcommunity-a.akamaihd.net/economy/image/-9a81dlWLwJ2UUGcVs_nsVtzdOEdtWwKGZZLQHTxDZ7I56KU0Zwwo4NUX4oFJZEHLbXH5ApeO4YmlhxYQknCRvCo04DEVlxkKgpopujwezhjxszFfjNH9eO6nYeDg8j4MqnWkyVQsJMi2OzF8dmt3AK28xBlNzzzLdWScwdvNQnU_Qe5lbu81pG_tc_O1zI97TldxTpO/200fx150f',
                'cost': '1.11'
            },
            {
                'id': 1,
                'name': 'R8 Revolver | Reboot',
                'wear': 'Minimal Wear',
                'rarity': 'cl_2',
                'imageSm': 'https://steamcommunity-a.akamaihd.net/economy/image/-9a81dlWLwJ2UUGcVs_nsVtzdOEdtWwKGZZLQHTxDZ7I56KU0Zwwo4NUX4oFJZEHLbXH5ApeO4YmlhxYQknCRvCo04DEVlxkKgpopL-zJAt21uH3cih9_oSJl5mJkuXnI7TDglRc7cF4n-T--Y3nj1H6r0ZuMm-lIoGQIwNsNF3W_la2l-m8hJe7vJqcyXQ26CEl4nfVyheyiAYMMLJhtAnBUQ/150fx100f',
                'imageBig': 'https://steamcommunity-a.akamaihd.net/economy/image/-9a81dlWLwJ2UUGcVs_nsVtzdOEdtWwKGZZLQHTxDZ7I56KU0Zwwo4NUX4oFJZEHLbXH5ApeO4YmlhxYQknCRvCo04DEVlxkKgpopL-zJAt21uH3cih9_oSJl5mJkuXnI7TDglRc7cF4n-T--Y3nj1H6r0ZuMm-lIoGQIwNsNF3W_la2l-m8hJe7vJqcyXQ26CEl4nfVyheyiAYMMLJhtAnBUQ/200fx150f',
                'cost': '2.22'
            },
            {
                'id': 2,
                'name': 'Tec-9 | toxic',
                'wear': 'Battle-Scarred',
                'rarity': 'cl_3',
                'imageSm': 'https://steamcommunity-a.akamaihd.net/economy/image/-9a81dlWLwJ2UUGcVs_nsVtzdOEdtWwKGZZLQHTxDZ7I56KU0Zwwo4NUX4oFJZEHLbXH5ApeO4YmlhxYQknCRvCo04DEVlxkKgpoor-mcjhoyszGZD5O6d2kq5OAgvv4IO7ugm5Ssfp9g-7J4bP5iUazrl04a2qnI9LAdlU_YQyCqVTokLvmh5PtuM6bzHFi6XEltHeJykDhgkxNcKUx0nqScxNZ/150fx100f',
                'imageBig': 'https://steamcommunity-a.akamaihd.net/economy/image/-9a81dlWLwJ2UUGcVs_nsVtzdOEdtWwKGZZLQHTxDZ7I56KU0Zwwo4NUX4oFJZEHLbXH5ApeO4YmlhxYQknCRvCo04DEVlxkKgpoor-mcjhoyszGZD5O6d2kq5OAgvv4IO7ugm5Ssfp9g-7J4bP5iUazrl04a2qnI9LAdlU_YQyCqVTokLvmh5PtuM6bzHFi6XEltHeJykDhgkxNcKUx0nqScxNZ/200fx150f',
                'cost': '3.33'
            },
            {
                'id': 3,
                'name': 'SSG 08 | Necropos',
                'wear': 'Well-Worn',
                'rarity': 'cl_4',
                'imageSm': 'https://steamcommunity-a.akamaihd.net/economy/image/-9a81dlWLwJ2UUGcVs_nsVtzdOEdtWwKGZZLQHTxDZ7I56KU0Zwwo4NUX4oFJZEHLbXH5ApeO4YmlhxYQknCRvCo04DEVlxkKgpopamie19f0Ob3Yi5FvISJmoWIhfjkPKjum25V4dB8teXA54vwxgfsrUQ4YjvxJYLHdwI4YVmGqFHqxO7v15G6uZubyHtl6XZ27X_YnhepwUYbGDyxDtI/150fx100f',
                'imageBig': 'https://steamcommunity-a.akamaihd.net/economy/image/-9a81dlWLwJ2UUGcVs_nsVtzdOEdtWwKGZZLQHTxDZ7I56KU0Zwwo4NUX4oFJZEHLbXH5ApeO4YmlhxYQknCRvCo04DEVlxkKgpopamie19f0Ob3Yi5FvISJmoWIhfjkPKjum25V4dB8teXA54vwxgfsrUQ4YjvxJYLHdwI4YVmGqFHqxO7v15G6uZubyHtl6XZ27X_YnhepwUYbGDyxDtI/200fx150f',
                'cost': '4.44'
            },
            {
                'id': 4,
                'name': 'mag-7 | heat',
                'wear': 'Factory New',
                'rarity': 'cl_5',
                'imageSm': 'https://steamcommunity-a.akamaihd.net/economy/image/-9a81dlWLwJ2UUGcVs_nsVtzdOEdtWwKGZZLQHTxDZ7I56KU0Zwwo4NUX4oFJZEHLbXH5ApeO4YmlhxYQknCRvCo04DEVlxkKgpou7uifDhjxszFcDoV086zkIiEg8j4OrzZglRd6dd2j6eWo9yt31Xs-EU5azr6LNDBcwY5Z12B_gO7x7q81J-4us-YzCMw6CR2-z-DyH05vt6N/150fx100f',
                'imageBig': 'https://steamcommunity-a.akamaihd.net/economy/image/-9a81dlWLwJ2UUGcVs_nsVtzdOEdtWwKGZZLQHTxDZ7I56KU0Zwwo4NUX4oFJZEHLbXH5ApeO4YmlhxYQknCRvCo04DEVlxkKgpou7uifDhjxszFcDoV086zkIiEg8j4OrzZglRd6dd2j6eWo9yt31Xs-EU5azr6LNDBcwY5Z12B_gO7x7q81J-4us-YzCMw6CR2-z-DyH05vt6N/200fx150f',
                'cost': '5.55'
            },
            {
                'id': 5,
                'name': 'AWP | paw',
                'wear': 'Not Painted',
                'rarity': 'cl_6',
                'imageSm': 'https://steamcommunity-a.akamaihd.net/economy/image/-9a81dlWLwJ2UUGcVs_nsVtzdOEdtWwKGZZLQHTxDZ7I56KU0Zwwo4NUX4oFJZEHLbXH5ApeO4YmlhxYQknCRvCo04DEVlxkKgpot621FAZt7PLfYQJS7cumlZe0m_7zO6_ummpD78A_2u_HpN2giwfl-ENrMDrwJYSXdwU4MlzUq1jvlLjo0JC4vprOnSFisz5iuygXqnotbQ/150fx100f',
                'imageBig': 'https://steamcommunity-a.akamaihd.net/economy/image/-9a81dlWLwJ2UUGcVs_nsVtzdOEdtWwKGZZLQHTxDZ7I56KU0Zwwo4NUX4oFJZEHLbXH5ApeO4YmlhxYQknCRvCo04DEVlxkKgpot621FAZt7PLfYQJS7cumlZe0m_7zO6_ummpD78A_2u_HpN2giwfl-ENrMDrwJYSXdwU4MlzUq1jvlLjo0JC4vprOnSFisz5iuygXqnotbQ/200fx150f',
                'cost': '6.66'
            }
        ]
    },
    {
        'caseId': 2,
        'caseName': 'Random Classifield',
        'caseImg': 'https://dropland.net/uploads/cases/WqL90.png',
        'caseCost': '2.99',
        'caseItems': [
            {
                'id': 0,
                'name': 'P250 | Franklin',
                'wear': 'Field-Tested',
                'rarity': 'cl_1',
                'imageSm': 'https://steamcommunity-a.akamaihd.net/economy/image/-9a81dlWLwJ2UUGcVs_nsVtzdOEdtWwKGZZLQHTxDZ7I56KU0Zwwo4NUX4oFJZEHLbXH5ApeO4YmlhxYQknCRvCo04DEVlxkKgpopujwezhjxszFfjNH9eO6nYeDg8j4MqnWkyVQsJMi2OzF8dmt3AK28xBlNzzzLdWScwdvNQnU_Qe5lbu81pG_tc_O1zI97TldxTpO/150fx100f',
                'imageBig': 'https://steamcommunity-a.akamaihd.net/economy/image/-9a81dlWLwJ2UUGcVs_nsVtzdOEdtWwKGZZLQHTxDZ7I56KU0Zwwo4NUX4oFJZEHLbXH5ApeO4YmlhxYQknCRvCo04DEVlxkKgpopujwezhjxszFfjNH9eO6nYeDg8j4MqnWkyVQsJMi2OzF8dmt3AK28xBlNzzzLdWScwdvNQnU_Qe5lbu81pG_tc_O1zI97TldxTpO/200fx150f',
                'cost': '1.11'
            },
            {
                'id': 1,
                'name': 'R8 Revolver | Reboot',
                'wear': 'Minimal Wear',
                'rarity': 'cl_2',
                'imageSm': 'https://steamcommunity-a.akamaihd.net/economy/image/-9a81dlWLwJ2UUGcVs_nsVtzdOEdtWwKGZZLQHTxDZ7I56KU0Zwwo4NUX4oFJZEHLbXH5ApeO4YmlhxYQknCRvCo04DEVlxkKgpopL-zJAt21uH3cih9_oSJl5mJkuXnI7TDglRc7cF4n-T--Y3nj1H6r0ZuMm-lIoGQIwNsNF3W_la2l-m8hJe7vJqcyXQ26CEl4nfVyheyiAYMMLJhtAnBUQ/150fx100f',
                'imageBig': 'https://steamcommunity-a.akamaihd.net/economy/image/-9a81dlWLwJ2UUGcVs_nsVtzdOEdtWwKGZZLQHTxDZ7I56KU0Zwwo4NUX4oFJZEHLbXH5ApeO4YmlhxYQknCRvCo04DEVlxkKgpopL-zJAt21uH3cih9_oSJl5mJkuXnI7TDglRc7cF4n-T--Y3nj1H6r0ZuMm-lIoGQIwNsNF3W_la2l-m8hJe7vJqcyXQ26CEl4nfVyheyiAYMMLJhtAnBUQ/200fx150f',
                'cost': '2.22'
            },
            {
                'id': 2,
                'name': 'Tec-9 | toxic',
                'wear': 'Battle-Scarred',
                'rarity': 'cl_3',
                'imageSm': 'https://steamcommunity-a.akamaihd.net/economy/image/-9a81dlWLwJ2UUGcVs_nsVtzdOEdtWwKGZZLQHTxDZ7I56KU0Zwwo4NUX4oFJZEHLbXH5ApeO4YmlhxYQknCRvCo04DEVlxkKgpoor-mcjhoyszGZD5O6d2kq5OAgvv4IO7ugm5Ssfp9g-7J4bP5iUazrl04a2qnI9LAdlU_YQyCqVTokLvmh5PtuM6bzHFi6XEltHeJykDhgkxNcKUx0nqScxNZ/150fx100f',
                'imageBig': 'https://steamcommunity-a.akamaihd.net/economy/image/-9a81dlWLwJ2UUGcVs_nsVtzdOEdtWwKGZZLQHTxDZ7I56KU0Zwwo4NUX4oFJZEHLbXH5ApeO4YmlhxYQknCRvCo04DEVlxkKgpoor-mcjhoyszGZD5O6d2kq5OAgvv4IO7ugm5Ssfp9g-7J4bP5iUazrl04a2qnI9LAdlU_YQyCqVTokLvmh5PtuM6bzHFi6XEltHeJykDhgkxNcKUx0nqScxNZ/200fx150f',
                'cost': '3.33'
            },
            {
                'id': 3,
                'name': 'SSG 08 | Necropos',
                'wear': 'Well-Worn',
                'rarity': 'cl_4',
                'imageSm': 'https://steamcommunity-a.akamaihd.net/economy/image/-9a81dlWLwJ2UUGcVs_nsVtzdOEdtWwKGZZLQHTxDZ7I56KU0Zwwo4NUX4oFJZEHLbXH5ApeO4YmlhxYQknCRvCo04DEVlxkKgpopamie19f0Ob3Yi5FvISJmoWIhfjkPKjum25V4dB8teXA54vwxgfsrUQ4YjvxJYLHdwI4YVmGqFHqxO7v15G6uZubyHtl6XZ27X_YnhepwUYbGDyxDtI/150fx100f',
                'imageBig': 'https://steamcommunity-a.akamaihd.net/economy/image/-9a81dlWLwJ2UUGcVs_nsVtzdOEdtWwKGZZLQHTxDZ7I56KU0Zwwo4NUX4oFJZEHLbXH5ApeO4YmlhxYQknCRvCo04DEVlxkKgpopamie19f0Ob3Yi5FvISJmoWIhfjkPKjum25V4dB8teXA54vwxgfsrUQ4YjvxJYLHdwI4YVmGqFHqxO7v15G6uZubyHtl6XZ27X_YnhepwUYbGDyxDtI/200fx150f',
                'cost': '4.44'
            },
            {
                'id': 4,
                'name': 'mag-7 | heat',
                'wear': 'Factory New',
                'rarity': 'cl_5',
                'imageSm': 'https://steamcommunity-a.akamaihd.net/economy/image/-9a81dlWLwJ2UUGcVs_nsVtzdOEdtWwKGZZLQHTxDZ7I56KU0Zwwo4NUX4oFJZEHLbXH5ApeO4YmlhxYQknCRvCo04DEVlxkKgpou7uifDhjxszFcDoV086zkIiEg8j4OrzZglRd6dd2j6eWo9yt31Xs-EU5azr6LNDBcwY5Z12B_gO7x7q81J-4us-YzCMw6CR2-z-DyH05vt6N/150fx100f',
                'imageBig': 'https://steamcommunity-a.akamaihd.net/economy/image/-9a81dlWLwJ2UUGcVs_nsVtzdOEdtWwKGZZLQHTxDZ7I56KU0Zwwo4NUX4oFJZEHLbXH5ApeO4YmlhxYQknCRvCo04DEVlxkKgpou7uifDhjxszFcDoV086zkIiEg8j4OrzZglRd6dd2j6eWo9yt31Xs-EU5azr6LNDBcwY5Z12B_gO7x7q81J-4us-YzCMw6CR2-z-DyH05vt6N/200fx150f',
                'cost': '5.55'
            },
            {
                'id': 5,
                'name': 'AWP | paw',
                'wear': 'Not Painted',
                'rarity': 'cl_6',
                'imageSm': 'https://steamcommunity-a.akamaihd.net/economy/image/-9a81dlWLwJ2UUGcVs_nsVtzdOEdtWwKGZZLQHTxDZ7I56KU0Zwwo4NUX4oFJZEHLbXH5ApeO4YmlhxYQknCRvCo04DEVlxkKgpot621FAZt7PLfYQJS7cumlZe0m_7zO6_ummpD78A_2u_HpN2giwfl-ENrMDrwJYSXdwU4MlzUq1jvlLjo0JC4vprOnSFisz5iuygXqnotbQ/150fx100f',
                'imageBig': 'https://steamcommunity-a.akamaihd.net/economy/image/-9a81dlWLwJ2UUGcVs_nsVtzdOEdtWwKGZZLQHTxDZ7I56KU0Zwwo4NUX4oFJZEHLbXH5ApeO4YmlhxYQknCRvCo04DEVlxkKgpot621FAZt7PLfYQJS7cumlZe0m_7zO6_ummpD78A_2u_HpN2giwfl-ENrMDrwJYSXdwU4MlzUq1jvlLjo0JC4vprOnSFisz5iuygXqnotbQ/200fx150f',
                'cost': '6.66'
            }
        ]
    },
    {
        'caseId': 3,
        'caseName': 'Random AWP',
        'caseImg': 'https://dropland.net/uploads/cases/uKuFU.png',
        'caseCost': '3.99',
        'caseItems': [
            {
                'id': 0,
                'name': 'P250 | Franklin',
                'wear': 'Field-Tested',
                'rarity': 'cl_1',
                'imageSm': 'https://steamcommunity-a.akamaihd.net/economy/image/-9a81dlWLwJ2UUGcVs_nsVtzdOEdtWwKGZZLQHTxDZ7I56KU0Zwwo4NUX4oFJZEHLbXH5ApeO4YmlhxYQknCRvCo04DEVlxkKgpopujwezhjxszFfjNH9eO6nYeDg8j4MqnWkyVQsJMi2OzF8dmt3AK28xBlNzzzLdWScwdvNQnU_Qe5lbu81pG_tc_O1zI97TldxTpO/150fx100f',
                'imageBig': 'https://steamcommunity-a.akamaihd.net/economy/image/-9a81dlWLwJ2UUGcVs_nsVtzdOEdtWwKGZZLQHTxDZ7I56KU0Zwwo4NUX4oFJZEHLbXH5ApeO4YmlhxYQknCRvCo04DEVlxkKgpopujwezhjxszFfjNH9eO6nYeDg8j4MqnWkyVQsJMi2OzF8dmt3AK28xBlNzzzLdWScwdvNQnU_Qe5lbu81pG_tc_O1zI97TldxTpO/200fx150f',
                'cost': '1.11'
            },
            {
                'id': 1,
                'name': 'R8 Revolver | Reboot',
                'wear': 'Minimal Wear',
                'rarity': 'cl_2',
                'imageSm': 'https://steamcommunity-a.akamaihd.net/economy/image/-9a81dlWLwJ2UUGcVs_nsVtzdOEdtWwKGZZLQHTxDZ7I56KU0Zwwo4NUX4oFJZEHLbXH5ApeO4YmlhxYQknCRvCo04DEVlxkKgpopL-zJAt21uH3cih9_oSJl5mJkuXnI7TDglRc7cF4n-T--Y3nj1H6r0ZuMm-lIoGQIwNsNF3W_la2l-m8hJe7vJqcyXQ26CEl4nfVyheyiAYMMLJhtAnBUQ/150fx100f',
                'imageBig': 'https://steamcommunity-a.akamaihd.net/economy/image/-9a81dlWLwJ2UUGcVs_nsVtzdOEdtWwKGZZLQHTxDZ7I56KU0Zwwo4NUX4oFJZEHLbXH5ApeO4YmlhxYQknCRvCo04DEVlxkKgpopL-zJAt21uH3cih9_oSJl5mJkuXnI7TDglRc7cF4n-T--Y3nj1H6r0ZuMm-lIoGQIwNsNF3W_la2l-m8hJe7vJqcyXQ26CEl4nfVyheyiAYMMLJhtAnBUQ/200fx150f',
                'cost': '2.22'
            },
            {
                'id': 2,
                'name': 'Tec-9 | toxic',
                'wear': 'Battle-Scarred',
                'rarity': 'cl_3',
                'imageSm': 'https://steamcommunity-a.akamaihd.net/economy/image/-9a81dlWLwJ2UUGcVs_nsVtzdOEdtWwKGZZLQHTxDZ7I56KU0Zwwo4NUX4oFJZEHLbXH5ApeO4YmlhxYQknCRvCo04DEVlxkKgpoor-mcjhoyszGZD5O6d2kq5OAgvv4IO7ugm5Ssfp9g-7J4bP5iUazrl04a2qnI9LAdlU_YQyCqVTokLvmh5PtuM6bzHFi6XEltHeJykDhgkxNcKUx0nqScxNZ/150fx100f',
                'imageBig': 'https://steamcommunity-a.akamaihd.net/economy/image/-9a81dlWLwJ2UUGcVs_nsVtzdOEdtWwKGZZLQHTxDZ7I56KU0Zwwo4NUX4oFJZEHLbXH5ApeO4YmlhxYQknCRvCo04DEVlxkKgpoor-mcjhoyszGZD5O6d2kq5OAgvv4IO7ugm5Ssfp9g-7J4bP5iUazrl04a2qnI9LAdlU_YQyCqVTokLvmh5PtuM6bzHFi6XEltHeJykDhgkxNcKUx0nqScxNZ/200fx150f',
                'cost': '3.33'
            },
            {
                'id': 3,
                'name': 'SSG 08 | Necropos',
                'wear': 'Well-Worn',
                'rarity': 'cl_4',
                'imageSm': 'https://steamcommunity-a.akamaihd.net/economy/image/-9a81dlWLwJ2UUGcVs_nsVtzdOEdtWwKGZZLQHTxDZ7I56KU0Zwwo4NUX4oFJZEHLbXH5ApeO4YmlhxYQknCRvCo04DEVlxkKgpopamie19f0Ob3Yi5FvISJmoWIhfjkPKjum25V4dB8teXA54vwxgfsrUQ4YjvxJYLHdwI4YVmGqFHqxO7v15G6uZubyHtl6XZ27X_YnhepwUYbGDyxDtI/150fx100f',
                'imageBig': 'https://steamcommunity-a.akamaihd.net/economy/image/-9a81dlWLwJ2UUGcVs_nsVtzdOEdtWwKGZZLQHTxDZ7I56KU0Zwwo4NUX4oFJZEHLbXH5ApeO4YmlhxYQknCRvCo04DEVlxkKgpopamie19f0Ob3Yi5FvISJmoWIhfjkPKjum25V4dB8teXA54vwxgfsrUQ4YjvxJYLHdwI4YVmGqFHqxO7v15G6uZubyHtl6XZ27X_YnhepwUYbGDyxDtI/200fx150f',
                'cost': '4.44'
            },
            {
                'id': 4,
                'name': 'mag-7 | heat',
                'wear': 'Factory New',
                'rarity': 'cl_5',
                'imageSm': 'https://steamcommunity-a.akamaihd.net/economy/image/-9a81dlWLwJ2UUGcVs_nsVtzdOEdtWwKGZZLQHTxDZ7I56KU0Zwwo4NUX4oFJZEHLbXH5ApeO4YmlhxYQknCRvCo04DEVlxkKgpou7uifDhjxszFcDoV086zkIiEg8j4OrzZglRd6dd2j6eWo9yt31Xs-EU5azr6LNDBcwY5Z12B_gO7x7q81J-4us-YzCMw6CR2-z-DyH05vt6N/150fx100f',
                'imageBig': 'https://steamcommunity-a.akamaihd.net/economy/image/-9a81dlWLwJ2UUGcVs_nsVtzdOEdtWwKGZZLQHTxDZ7I56KU0Zwwo4NUX4oFJZEHLbXH5ApeO4YmlhxYQknCRvCo04DEVlxkKgpou7uifDhjxszFcDoV086zkIiEg8j4OrzZglRd6dd2j6eWo9yt31Xs-EU5azr6LNDBcwY5Z12B_gO7x7q81J-4us-YzCMw6CR2-z-DyH05vt6N/200fx150f',
                'cost': '5.55'
            },
            {
                'id': 5,
                'name': 'AWP | paw',
                'wear': 'Not Painted',
                'rarity': 'cl_6',
                'imageSm': 'https://steamcommunity-a.akamaihd.net/economy/image/-9a81dlWLwJ2UUGcVs_nsVtzdOEdtWwKGZZLQHTxDZ7I56KU0Zwwo4NUX4oFJZEHLbXH5ApeO4YmlhxYQknCRvCo04DEVlxkKgpot621FAZt7PLfYQJS7cumlZe0m_7zO6_ummpD78A_2u_HpN2giwfl-ENrMDrwJYSXdwU4MlzUq1jvlLjo0JC4vprOnSFisz5iuygXqnotbQ/150fx100f',
                'imageBig': 'https://steamcommunity-a.akamaihd.net/economy/image/-9a81dlWLwJ2UUGcVs_nsVtzdOEdtWwKGZZLQHTxDZ7I56KU0Zwwo4NUX4oFJZEHLbXH5ApeO4YmlhxYQknCRvCo04DEVlxkKgpot621FAZt7PLfYQJS7cumlZe0m_7zO6_ummpD78A_2u_HpN2giwfl-ENrMDrwJYSXdwU4MlzUq1jvlLjo0JC4vprOnSFisz5iuygXqnotbQ/200fx150f',
                'cost': '6.66'
            }
        ]
    }
];
*/
